// import React, { useState } from 'react'
// import { Form, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./ContactMe.css"
// import axios from 'axios';
// import toast, { Toaster } from 'react-hot-toast';
// import resume from "../../assets/Resume.pdf"

export default function ContactMe() {
  // const resumeUrl = 'Resume.pdf';
//   const [Name , setName ] = useState("")
//   const [Email , setEmail] = useState("")
//   const [Subject , setSubject] = useState("")
//   const [Description , setDescription] = useState("")
//   const [isDisabled, setIsDisabled] = useState(false);
  // const SendSuggestion = async (e) => {
  //   e.preventDefault();

  //   // Basic form validation
  //   if (!Name || !Email || !Subject || !Description) {
  //     toast.error('Please fill in all fields!', {
  //       duration: 3000,
  //       icon: '❌',
  //     });
  //     return;
  //   }

  //   setIsDisabled(true);
  //   try {
  //     await axios.post("https://suggestionsender.azurewebsites.net/", {
  //       name: Name,
  //       email: Email,
  //       subject: Subject,
  //       text: Description,
  //     });
  //     setDescription("");
  //     setEmail("");
  //     setName("");
  //     setSubject("");

  //     toast.success('Code upgraded, appreciate the input! More tweaks?', {
  //       duration: 5000,
  //       icon: '🚀',
  //     });
  //   } catch (err) {
  //     console.error(err);
  //     toast.error('Submission failed. Please try again later.', {
  //       duration: 3000,
  //       icon: '❌',
  //     });
  //   } finally {
  //     setTimeout(() => {
  //       setIsDisabled(false);
  //     }, 5000);
  //   };
  // };


  return (
    <section className='Contactme reveal' id="Contact">
      {/* <Toaster position='bottom-left' reverseOrder={false} /> */}
      <div className='contact-Header'>
        <header>Contact Me</header>
      </div>
      <div className='Contact-page'>
        <div className='Contact-data'>
          <p className="Contact-para">
            Do You Speak Binary.......? It's Okay if you don't I speak English too.
            Let's Chat....
          </p>
          <div className="Contact-icon">
            <span class="icon1">
              <a href="mailto:sajjapremsai.in@gmail.com" target="_blank" rel="noreferrer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  class="bi bi-envelope"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-5.761 3.459a1 1 0 0 1-1.478 0L2 5.383V12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5.383z" />
                </svg>
              </a>
            </span>

            <span className='icon2'>
              <a href="https://github.com/SajjaPremsai" target="_blank" rel="noreferrer">
              <svg
              
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                class="bi bi-github"
                viewBox="0 0 16 16"
              >
                <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
              </svg>
              </a>
            </span>
            <span className='icon3'>
              <a href="https://www.linkedin.com/in/sajjapremsai" target="_blank" rel="noreferrer">
              <svg
              
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                class="bi bi-linkedin"
                viewBox="0 0 16 16"
              >
                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
              </svg>
              </a>
            </span>
            <span></span>
          </div>
        </div>
      <div className='Contact-Form'>
          
        

          {/* <Form autoComplete="off">
          <header className='Form-header'>Suggestions</header>
          <Form.Group className="mb-3" controlId="formName" required >
            <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" value={Name} required onChange={HandelName} autoComplete="off" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" value={Email} required onChange={HandelEmail} autoComplete="off" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formSubject">
            <Form.Label>Subject</Form.Label>
              <Form.Control type="text" placeholder="Enter subject" value={Subject} required onChange={HandelSubject} autoComplete="off" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formDescription">
            <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={4} placeholder="Enter description" value={Description} required onChange={HandelDescription} autoComplete='off' />
          </Form.Group>

            <Button variant="primary" type="submit" style={{ backgroundColor: "#EC4D37", borderColor: "#EC4D37" }} onClick={SendSuggestion} disabled={isDisabled}>
            Submit
          </Button>
        </Form> */}
      </div>
      </div>
    </section>
  )
}